import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=423bbd3e&scoped=true"
import script from "./Attestation.vue?vue&type=script&lang=js"
export * from "./Attestation.vue?vue&type=script&lang=js"
import style0 from "./Attestation.vue?vue&type=style&index=0&id=423bbd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423bbd3e",
  null
  
)

export default component.exports